<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { HomePostUserInfo } from "@/api/gxHome/api.home";
// import { isManager } from "@/api/apps/index.js";
export default {
  name: "Home",
  data() {
    return {};
  },
  created() {
    this.hasLogin();
  },
  methods: {
    hasLogin() {
      let token = this.$route.query.token;

      if (token) {
        window.sessionStorage.setItem("SSOP_TOKEN", token);
        let wHref = window.location.href;
        let targetHref = "";
        let targetQuery = "";
        if (wHref.indexOf("?") !== -1) {
          targetHref = wHref.slice(0, wHref.indexOf("?"));
          for (let key in this.$route.query) {
            if (key === "token") {
              continue;
            } else {
              targetQuery += `${key}=${this.$route.query[key]}&`;
            }
          }
          if (targetQuery) {
            targetQuery = targetQuery.slice(0, -1);
            window.location.href = targetHref + `?${targetQuery}`;
          } else {
            window.location.href = targetHref;
          }
        }
        this.getUserInfo();
      } else {
        let curToken = window.sessionStorage.getItem("SSOP_TOKEN");
        if (curToken) {
          this.getUserInfo();
        } else {
          //  this.$_goToLogin();
        }
        window.sessionStorage.removeItem("hasTakeToken");
      }
    },
    getUserInfo() {
      HomePostUserInfo().then((res) => {
        if (res && res.result) {
          sessionStorage.setItem("ssop_user_info", JSON.stringify(res.result));
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/css/reset.scss";
#app{
  // min-width: 1300px;
}
</style>
